import RemoteConfigService from "../../../components/RemoteConfigService";
import Constants from "../../../components/Constants";
import cookieManager from "../../../components/CookieManager";
import LoginHelper from "../../../components/LoginHelper";

export const getBuildName = () => {
    const params = new URLSearchParams(window.location.search);
    const paramBuild = params.get("build");

    if (paramBuild) {
        console.log(`[urlParams] Build version from URL param: ${paramBuild}`);
        return paramBuild;
    }

    const configBuild = RemoteConfigService.getWebGLBuildNameByEnvironment();
    if (configBuild) {
        console.log(`[urlParams] Build version from RemoteConfigService: ${configBuild}`);
        return configBuild;
    }

    console.log("[urlParams] No build version found — returning null");
    return null;
};

export const getBuildVersion = (buildName) => {
    if (typeof buildName !== "string") return "";

    const parts = buildName.split("-").filter(Boolean);

    for (let i = 0; i <= parts.length - 4; i++) {
        // Looking for pattern: number-number-number-string (e.g. 8-2-3-RED)
        const a = parts[i], b = parts[i + 1], c = parts[i + 2], ns = parts[i + 3];
        // return as a.b.c (e.g. 8.2.3)
        if (/^\d+$/.test(a) && /^\d+$/.test(b) && /^\d+$/.test(c) && /^[A-Za-z0-9_]+$/.test(ns)) {
            return `${+a}.${+b}.${+c}`;
        }
    }
    return "";
};

export const getLanguage = () => {
  const params = new URLSearchParams(window.location.search);
  const lang = params.get("lang");

  if (lang) {
    return lang;
  }

  return null;
};

export function stripParamFromUrl(paramName) {
    try {
        const url = new URL(window.location.href);
        let changed = false;

        if (url.searchParams.has(paramName)) {
            url.searchParams.delete(paramName);
            changed = true;
        }

        if (url.hash && url.hash.includes("?")) {
            const hashRaw = url.hash.slice(1);
            const [hashPath, hashQuery = ""] = hashRaw.split("?");
            const hashParams = new URLSearchParams(hashQuery);

            if (hashParams.has(paramName)) {
                hashParams.delete(paramName);
                changed = true;
            }

            const newHashQuery = hashParams.toString();
            url.hash = newHashQuery ? `#${hashPath}?${newHashQuery}` : `#${hashPath || ""}`;
        }

        if (changed) {
            window.history.replaceState(null, "", url.toString());
            console.log(`[urlParams] Stripped "${paramName}" from URL`);
        }
        return changed;
    } catch (e) {
        console.warn("[urlParams] Could not strip param:", paramName, e);
        return false;
    }
}

function setCookieFromParam(name, value) {
    if (!value) return false;
    cookieManager.remove(name);
    cookieManager.set(name, value);
    console.log(`[Game] URL had ${name} (stored in cookie)`);
    stripParamFromUrl(name);
    return true;
}

export async function setupTokens() {
    const readParam = (name) => {
        const fromQuery = new URLSearchParams(window.location.search).get(name);
        if (fromQuery) return fromQuery;

        if (window.location.hash.includes("?")) {
            const [, hashQuery = ""] = window.location.hash.slice(1).split("?");
            return new URLSearchParams(hashQuery).get(name);
        }
        return null;
    };

    console.log("[Game] Checking URL params for tokens...");

    const accessToken = readParam(Constants.ACCESS_TOKEN);
    const exchangeCode = readParam(Constants.EXCHANGE_CODE);

    // Case A: accessToken present in URL → store all tokens directly (fast path).
    if (accessToken) {
        const refreshToken = readParam(Constants.REFRESH_TOKEN);
        const skillsId = readParam(Constants.SKILLS_ID);
        [
            [Constants.ACCESS_TOKEN,  accessToken],
            [Constants.REFRESH_TOKEN, refreshToken],
            [Constants.SKILLS_ID,     skillsId],
        ].forEach(([name, value]) => setCookieFromParam(name, value));
        return;
    }

    // Case B: single-use exchange code present → redeem it for a fresh session.
    // On success: strip the param and hard-reload so React/Unity state starts
    // from scratch under the new identity (no stale in-memory state from the
    // previous user). On failure: just strip; the user must go back to the
    // app and reopen the popup to get a new code.
    // TODO: when Unity supports it, signal "code expired/consumed" back to
    // the client so the popup is regenerated automatically.
    if (exchangeCode) {
        console.log("[Game] Auto-login via exchange code from URL");
        try {
            await LoginHelper.LoginWithExchangeCode(exchangeCode);
            stripParamFromUrl(Constants.EXCHANGE_CODE);
            window.location.reload();
            return;
        } catch (e) {
            console.error("[Game] Auto-login with exchange code failed:", e);
            stripParamFromUrl(Constants.EXCHANGE_CODE);
        }
    }
}
